import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.92 2.62a1 1 0 00-.54-.54A1 1 0 0029 2h-8a1 1 0 100 2h5.6L12.29 18.3a1 1 0 000 1.41A1 1 0 0013 20a1 1 0 00.7-.29L28 5.4V11a1 1 0 102 0V3a1 1 0 00-.08-.38z"/><path d="M27 19a1 1 0 00-1 1v8H4V6h9a1 1 0 000-2H4a2 2 0 00-2 2v22a2 2 0 002 2h22a2 2 0 002-2v-8a1 1 0 00-1-1z"/>';
export var ExternalSVG = function ExternalSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ExternalSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ExternalSVG);